import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const WebPage = () => (
  <Layout>
    <SEO title="Jual aplikasi kasir online website" />
    <div class="masthead-followup row m-0 text-center">
<div class="col-12 col-md-12 p-3 p-md-5 bg-white text-center">
    <h3>Order Applikasi + Website</h3>
<p>Untuk order aplikasi + website silahkan transfer nominal Rp.1.550.000 ke rekening pembayaran kami berikut ini :</p>
<hr/>
<p>BCA Bank</p><hr/>
<p>No rek : 0181884109</p><hr/>
<p>Account : Suci Chanifah</p><hr/>
<p>Setelah melakukan pembayaran silahkan konfirmasi dan kirimkan bukti pembayaran serta ID anda via whatsapp maupun email ke staff kami agar pesanan segera diprogress, klik link berikut untuk konfirmasi.</p>
<a class="button" title="call us now" href="tel:+6285331361404" target="blank" rel="nofollow"> Chat</a> <a class="button" title="call us now" href="tel:+6285331361404" target="blank" rel="nofollow">Call</a>
<br/>
<Link to="/">Home Page</Link>
</div>
</div>
  </Layout>
)

export default WebPage
